import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type MassUpdateEventPayloadFragment = (
  { readonly __typename?: 'MassUpdateEvent' }
  & Pick<TP.MassUpdateEvent, 'id' | 'updateType' | 'outcome' | 'source'>
  & { massUpdateRouteId: TP.MassUpdateEvent['routeId'], massUpdateCorrelationId: TP.MassUpdateEvent['correlationId'], massUpdateErrorMessage: TP.MassUpdateEvent['errorMessage'], massUpdateWarningMessage: TP.MassUpdateEvent['warningMessage'] }
);

export const MassUpdateEventPayloadFragmentDoc = gql`
    fragment MassUpdateEventPayload on MassUpdateEvent {
  id
  updateType
  massUpdateRouteId: routeId
  outcome
  source
  massUpdateCorrelationId: correlationId
  massUpdateErrorMessage: errorMessage
  massUpdateWarningMessage: warningMessage
}
    `;